import smoothscroll from 'smoothscroll-polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import { EmpathyXAPI } from './api/api.interfaces';
import { AppBuilder } from './builders';
import { container } from './container';
import { initContainer } from './container/container.init';
import { DEPENDENCIES } from './container/dependencies.const';

declare global {
  interface Window {
    EmpathyX: EmpathyXAPI;
  }
}

export function installEmpathyX(configure?: (appBuilder: AppBuilder) => void) {
  smoothscroll.polyfill();
  initContainer();
  Vue.use(Vuex);
  Vue.config.productionTip = false;
  addVueCustomKeys();
  window.EmpathyX = container.get<EmpathyXAPI>(DEPENDENCIES.EmpathyXAPI);
  if (configure) {
    const appBuilder = container.get<AppBuilder>(DEPENDENCIES.AppBuilder);
    appBuilder.setConfigFor('mobile');
    appBuilder.setConfigFor('desktop');
    configure(appBuilder);
  }
}

function addVueCustomKeys() {
  Vue.config.keyCodes.home = 36;
  Vue.config.keyCodes.end = 35;
}
